import { createSelector } from '@ngrx/store';
import type { ApplicationState } from '../../../reducers';

export interface AuthState {
  authenticatedToken: string;
}

export const initialAuthState: AuthState = {
  authenticatedToken: null,
};

export const getAuthState = (state: ApplicationState) => state.auth;

export const getValidAuthToken = createSelector(getAuthState, (state: AuthState) => state.authenticatedToken);
